import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from 'src/app/Models/Classes/utils';
import { FormServiceService } from 'src/app/services/publications/form-service.service';

/**
 * Keeps public discovery public, while taking a guest to registration only
 * after they deliberately attempt an account-level action.
 */
@Injectable({ providedIn: 'root' })
export class RegistrationIntentService {
  private registrationNavigationPending = false;

  constructor(
    private formService: FormServiceService,
    private utils: Utils,
    private router: Router,
  ) {}

  async requireAccount(intent: string, returnUrl = this.router.url): Promise<boolean> {
    if (this.formService.profile) return true;

    try {
      // Profile hydration can still be in flight immediately after launch.
      // A persisted access token remains authoritative during that short gap.
      await this.utils.getAccessData();
      return true;
    } catch {
      if (!this.registrationNavigationPending) {
        this.registrationNavigationPending = true;
        try {
          await this.router.navigate(['/register'], {
            queryParams: {
              intent,
              returnUrl: this.safeReturnUrl(returnUrl),
            },
          });
        } finally {
          this.registrationNavigationPending = false;
        }
      }
      return false;
    }
  }

  private safeReturnUrl(url: string): string {
    const candidate = String(url || '').trim();
    return candidate.startsWith('/') && !candidate.startsWith('//')
      ? candidate
      : '/home/ecosystem-page';
  }
}
